import React from 'react';
import ReactDOM from 'react-dom';
import { compose } from 'lodash/fp';
import styled from 'styled-components';
import { withUserLayoutChoice, withTranslation } from 'components/hoc';
import { isEmptyValue } from 'components/utils/checkValue';
import { DnD } from './DnD';
import {
  DnDWrapper,
  Modal,
  StyledButton as Button,
  InnerContainer,
  Title,
} from './styled';
import Icon from 'components/Icon';
import { LayoutThreeColumns, Table } from 'react-bootstrap-icons';
import { Grid1x2Fill } from 'react-bootstrap-icons';

const StyledButton = styled(Button)`
  background: var(--admincat-color-grey-6);
  border-radius: 2px;
  height: 38px;
  color: ${(props) => props.color || 'var(--admincat-color-grey-7)'};
  border: none;
  font-size: 14px;
  line-height: 10px;

  display: flex;
  align-items: center;
  gap: 8px;

  @media screen and (max-width: 767px) {
    min-width: 38px;
    width: 38px;
    padding: 0;
    justify-content: center;
    gap: 0;
    font-size: 0;
    svg {
      display: inline-block !important;
      font-size: 16px;
      margin: 0 !important;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) {
    gap: 12px;
    svg { margin-right: 8px; }
  }

  @media screen and (min-width: 1025px) {
    font-size: 14px !important;
    gap: 8px;
  }

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

class DnDModal extends React.Component {
  parent = document.body;
  elem = document.createElement('div');
  items = [];

  state = { loading: false };

  static defaultProps = {
    tr: (v) => v,
  };

  componentDidMount() {
    this.parent.appendChild(this.elem);
  }

  componentWillUnmount() {
    this.parent.removeChild(this.elem);
  }

  setItems = (items) => {
    this.items = items;
  };

  onSubmit = async () => {
    const { tableName, updateUserLayoutChoice, togglePortal } = this.props;
    const user = JSON.parse(localStorage.user);
    console.log('tableName', tableName);
    console.log('updateUserLayoutChoice', updateUserLayoutChoice);
    try {
      this.setState({ loading: true });
      if (isEmptyValue(this.items)) {
        // togglePortal()
        return;
      }
      const items = this.items.map(({ id, label, ...rest }) => ({
        ...rest,
        frontend_table: tableName,
        user: user.user_id,
      }));
      console.log('items', items);

      await updateUserLayoutChoice({
        layout_choice_list: items,
      });
    } finally {
      this.setState({ loading: false });
      this.items = [];
      togglePortal();
    }
  };

  renderChildren = () => {
    const { showPortal, togglePortal, className, columns, tr } = this.props;

    const { loading } = this.state;

    return (
      showPortal && (
        <Modal className={className}>
          <InnerContainer>
            <Title>{tr('Selected Fields')}</Title>
            <DnDWrapper>
              <DnD columns={columns} setItems={this.setItems} tr={tr} />
            </DnDWrapper>
            <div className="card-footer text-right">
              <div className="d-flex">
                <Button
                  type="button"
                  name="Cancel"
                  onClick={togglePortal}
                  className="_btn-link"
                />
                <Button
                  type="button"
                  className="btn-primary"
                  isLoading={loading}
                  onClick={this.onSubmit}
                  name="Save"
                />
              </div>
            </div>
          </InnerContainer>
        </Modal>
      )
    );
  };

  render() {
    return ReactDOM.createPortal(this.renderChildren(), this.elem);
  }
}

class DnDPortalComponent extends React.Component {
  state = { showPortal: false };

  togglePortal = () => {
    const { showPortal } = this.state;
    this.setState({ showPortal: !showPortal });
  };

  render() {
    const { showPortal } = this.state;
    return (
      <>
        <StyledButton
          reactIcon={<Grid1x2Fill color="#4C81BE" size={12} className="mr-2" />}
          name="Layout"
          onClick={this.togglePortal}
        />
        <DnDModal
          {...this.props}
          showPortal={showPortal}
          togglePortal={this.togglePortal}
        />
      </>
    );
  }
}

export const DnDPortal = compose(
  withUserLayoutChoice,
  withTranslation,
)(DnDPortalComponent);
